import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type PurchaseRequestForFilterT = {
  company_id?: string;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  company_id,
  errorCallback = () => {},
  successCallback = () => {},
  resultKey = 'purchaseRequestListForFilter',
}: PurchaseRequestForFilterT) =>
  requestAsync({
    url: `${endpoints.getPurchaseRequestListURL()}/numbers_list?company_id=${company_id}`,
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getPurchaseRequestListURL()}/numbers_list?company_id=${company_id}`,
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
